import React, { useEffect, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/* import element from component folder */
import Table from "../../modelTable";

/* import function from store folder */
import { setAction } from '../../../store/components/searchSlice';
import { resetModel } from '../../../store/components/modelSlice';
import { setMessage } from '../../../store/components/alertSlice';

/* import fetch function */
import { EditCompaniesManagers, FetchValidateEmail, FetchBusinessManagers } from "../../../services/companies";

const CreateCompanies = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [tableLists, setTableLists] = useState([]);
    const { data } = useSelector(state => state.model);
    const [source, setSource] = useState({
        businessManagers: ''
    });
    
    const cancelHandler = () => dispatch(resetModel());
    const changHandler = ({target: { name, value }}) => {
        const _source = Object.assign({}, source);
        
        delete error[name];
        _source[name] = value;
        
        setError(error);
        setSource(_source);
    };

    const submitHandler = event => {
        event.preventDefault();
        const isValidate = validate();
        
        if (isValidate) {
            const _source = {
                companyName: source.companyName,
                mainContactUId: source.mainContactUId,
                businessManagerUIds: source.businessManagerUIds
            };
            
            EditCompaniesManagers({ bId: data.bId, source: _source }).then(response => {
                if (!Object.keys(response).length) {
                    cancelHandler();
                    dispatch(setAction());
                }
            });
        }
    };

    const removeHandle = removeId => {
        const _source = Object.assign({}, source);
        const _tableLists = [...tableLists];
        const index = _source.businessManagerUIds.indexOf(removeId);
        const listIndex = tableLists.findIndex(({ uId }) => uId === removeId);
        
        if (index > -1)
            _source.businessManagerUIds.splice(index, 1);

        if (listIndex > -1)
            _tableLists.splice(listIndex, 1);

        setSource(_source);
        setTableLists(_tableLists);
    };

    const checkHandle = isContact => {
        const request = { email: '' };
        const { mainContact, businessManagers } = source;

        if (!mainContact && !businessManagers) return;
        else if (isContact && mainContact)
            request.email = mainContact;
        else if (!isContact && businessManagers)
            request.email = businessManagers;

        if (request.email.length) {
            FetchValidateEmail(request).then(response => {
                const _source = Object.assign({}, source);

                if (isContact) {
                    _source.mainContactUId = response.uId;
                }
                else {
                    if (!_source.businessManagerUIds)
                        _source.businessManagerUIds = new Array();
                    
                    if (response.uId && !_source.businessManagerUIds.includes(response.uId)) {
                        _source.businessManagerUIds.push(response.uId);
                        setTableLists(items => [...items, response]);
                    }

                    _source.businessManagers = '';
                }
                
                setSource(_source);
                dispatch(setMessage({ message: '成功', variant: 'success' }));
            });
        }
    };

    const validate = () => {
        const checkLists = ['companyName', 'mainContactUId'];
        const _errors = {};

        checkLists.map( list => (
            (!source[list]) && ( _errors[list] = true)
        ));
        
        if (Object.keys(_errors).length) {
            setError(_errors);
            return false;
        }

        return true;
    };

    useEffect(() => {
        const request = { bId: data.bId, searches: { skip: 0, top: 999 } };
        const _source = {
            businessManagers: '',
            businessManagerUIds: [],
            companyName: data.companyName,
            mainContactUId: data.mainContactUId
        };

        FetchBusinessManagers(request).then(({ data }) => {
            data.forEach(({ uId }) => {
                _source.businessManagerUIds.push(uId);
            });
            
            setTableLists(data);
        });

        setSource(_source);
    }, [])

    return (
        <Modal show={ true } centered size='lg'>
            <Modal.Header>Create Date</Modal.Header>
            <Modal.Body>
                <Form className="modal-form-container" onSubmit={ submitHandler }>
                    <div className="form-item">
                        <div className='label'>Name</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='companyName' placeholder='Please enter the company name.' is-required={`${error.companyName}`} defaultValue={ data.companyName } onChange={ changHandler } />
                    </div>
                    <div className="form-item">
                        <div className='label'>Main Contact</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='mainContact' placeholder='Please enter the contact’s mail.' is-required={`${error.mainContactUId}`} defaultValue={ data.mainContactEmail } onChange={ changHandler } />
                        <Button type="button" data-shadow onClick={ () => checkHandle(true) }>Check</Button>
                    </div>
                    <div className="form-item">
                        <div className='label'>Business Managers</div>
                        <span className='semicolon'>：</span>
                        <Form.Control name='businessManagers' placeholder='Please enter the  mail.' value={ source.businessManagers } onChange={ changHandler } />
                        <Button type="button" data-shadow onClick={ () => checkHandle(false) }>Add</Button>
                    </div>
                    <div className="form-item">
                        <Table header={ [
                            { key: 'email', value: 'Email' },
                            { key: 'name', value: 'Name' },
                            { key: 'delete', value: 'Delete' }
                            ] } body={ tableLists } totalCount={ tableLists.length } action={ { delete: removeHandle } } idKey="uId" />
                    </div>
                    <div className="button-container">
                        <Button type="button" data-shadow onClick={ cancelHandler }>Cancel</Button>
                        <Button type="button" data-shadow onClick={ submitHandler }>Submit</Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default CreateCompanies;